<template>
    <v-dialog v-model="dialog" width="800" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field
                                v-model="title"
                                :rules="[formRules.required]"
                                label="Title"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="code"
                                :rules="[formRules.required]"
                                label="Course Code"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="unit"
                                :rules="[formRules.required]"
                                label="Unit"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="hours_lecture"
                                :rules="[formRules.required]"
                                label="Hours Lecture(Unit)"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="hours_lab"
                                :rules="[formRules.required]"
                                label="Hours Lab(Unit)"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-switch
                                v-model="status"
                                label="Is Active"
                                color="primary"
                                inset
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    emits: ["refresh"],
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            code: null,
            title: null,
            hours_lecture: null,
            hours_lab: null,
            unit: null,
            status: true,
        }
    },
    methods: {
        initAdd(){
            this.dialog = true
            this.dialog_title = 'Courses'
            this.dialog_sub_title = 'Add new course information'
            this.action = 'add'
            
            this.status = true
        },
        initEdit(data){
            this.dialog = true
            this.dialog_title = 'Courses'
            this.dialog_sub_title = 'Update course information'
            this.action = 'edit'

            this.id = data.id
            this.code = data.code
            this.title = data.title
            this.unit = data.unit
            this.hours_lecture = data.hours_lecture
            this.hours_lab = data.hours_lab
            this.status = data.status
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    code: this.code,
                    title: this.title,
                    hours_lecture: this.hours_lecture,
                    hours_lab: this.hours_lab,
                    unit: this.unit,
                    status: this.status,
                    program_id: this.$store.state.user.program.id
                }

                const token = localStorage.getItem('aums-token')

                if(this.action == 'add'){
                    axios.post(process.env.VUE_APP_SERVER_URL + '/course', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Course successfully added!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
                else if(this.action == 'edit'){
                    axios.patch(process.env.VUE_APP_SERVER_URL + '/course/' + this.id, formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Course successfully updated!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
    }
})
</script>

<style scoped>

</style>